import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/unlock-platform.png'


const _withScopeId = n => (_pushScopeId("data-v-28719e21"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__content__wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "platfotm_image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_content" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Unlock the Full Platform for FREE*"),
  /*#__PURE__*/_createElementVNode("p", null, " Unlock all areas of iknowa platform, FREE* until 1st April 2025. On 1st April 2025, your free membership will automatically roll onto one of the plans below that you select, unless you opt to cancel. "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, " Please note:"),
    /*#__PURE__*/_createTextVNode(" Payment card registration is required. ")
  ])
], -1))
const _hoisted_4 = { class: "modal__footer" }

import { TRADE_NETWORK } from "@/store/modules/trade-network";
import CommonDialog from "@/core/components/CommonDialog.vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'UnlockFreeAccessModal',
  emits: ["close", "onClickUnlockFreeAccess"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const emit = __emit;

const onClickCloseButton = (event: any) => {
  emit("close");
};
const onClickContinueButton = () => {
  emit("onClickUnlockFreeAccess");
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CommonDialog, {
      isShowHeader: false,
      isShowBackButton: false,
      width: "655px",
      "max-width": "100%",
      className: ['unlock_platform__modal']
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "modal_close",
            onClick: onClickCloseButton
          }, [
            _createVNode(_component_v_icon, { icon: "mdi-close" })
          ]),
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_btn, {
              class: "button button-purple-border",
              onClick: onClickCloseButton
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "button button-purple",
              onClick: onClickContinueButton
            }, {
              default: _withCtx(() => [
                _createTextVNode("Unlock For Free Now ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})